export default __webpack_public_path__ + "0851776f88981901b18f13247d5c2c43.svg";